var _a;
const e = up.element;
up.Layer.Root = (_a = class Root extends up.Layer {
        get element() {
            return e.root;
        }
        constructor(options) {
            super(options);
            this.setupHandlers();
        }
        getFirstSwappableElement() {
            return document.body;
        }
        static selector() {
            return 'html';
        }
        setupHandlers() {
            if (!this.element.upHandlersApplied) {
                this.element.upHandlersApplied = true;
                super.setupHandlers();
            }
        }
        sync() {
            this.setupHandlers();
        }
        isAlive() {
            return true;
        }
        accept() {
            this._cannotCloseRoot();
        }
        dismiss() {
            this._cannotCloseRoot();
        }
        _cannotCloseRoot() {
            up.fail('Cannot close the root layer');
        }
        toString() {
            return "root layer";
        }
    },
    _a.mode = 'root',
    _a);
